import { Form } from "../_forms";
import { OnInit, ViewChild } from "@angular/core";
import { downloadFromUrl } from "../_helpers";
import * as moment from "moment";
import {
  Campaign,
  CRMCampaign,
  CRMTypeId,
  FunnelStep,
  Pager,
  User,
  ReportSessionInput,
  ReportsUserConfiguration, ReasonCategory,
} from '../_models';
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import {
  AccountService,
  AlertService,
  CampaignProductService,
  CampaignService,
  CampaignTrackingService, CancelReasonCategoryService,
  CRMCampaignService,
  FunnelStepService,
  MerchantService,
  ReportsAbstractService,
  ReportsConfigService,
  StorageService,
  UserService,
} from '../_services';
import * as momentTz from "moment-timezone";
import { config } from "../../config/config";
import { catchError, takeUntil, tap } from "rxjs/operators";
import { Subject, forkJoin, of } from "rxjs";
import { Moment } from "moment";
import { DaterangepickerDirective } from "ngx-daterangepicker-material";
import {
  FilterType,
  MultiOption,
  MultiOptions,
  MultiSubOption,
  MultiSubOptions,
} from "../custom-multi-select/multi-select";
import { ReportTableV2Component } from "./report-table-v2.component";
import { get, isEmpty } from "lodash";
import { MatExpansionPanel } from "@angular/material";
import { CampaignProductsRequest } from "./models/campaignProducts";
import {chargebackFilters, ignoredSummaryFields} from './utils/constants';
import { reportsFieldDataV2 } from "./utils/reportsFieldData";
import {ReportDimensionCategories, ReportDimensions, ReportFieldData, ReportMode, ReportTypes} from './models/reports';
import { NgxSmartModalService } from "ngx-smart-modal";
import { ProductTypeEnum } from "../_models/product";

export abstract class ReportsAbstractV2Component
  extends Form
  implements OnInit
{
  @ViewChild(DaterangepickerDirective, { static: false })
  pickerDirective: DaterangepickerDirective;
  @ViewChild(ReportTableV2Component, { static: false })
  reportsTable: ReportTableV2Component;
  @ViewChild("panel", { static: false }) panel: MatExpansionPanel;
  @ViewChild("tablePanel", { static: false }) tablePanel: MatExpansionPanel;
  currentUser: User;
  campaigns: Campaign[] = [];
  isMenuVisible: boolean = false;
  selectedProductMap = new Map<number, any>();
  reportTitle = "";
  fields: MultiOptions = [];
  predefinedFields = [
    "exclude_hangups",
    "exclude_unknowns",
    "exclude_child_sessions",
    "exclude_child_orders",
    "exclude_zeroes",
    "exclude_tests"
  ];
  filters: MultiOptions = [];
  predefinedFilters;
  selectedDimensions: MultiSubOptions = [];
  selectedDimensionsList: string[] = [];
  selectedFilters: MultiOptions = [];
  reportsData: any;
  selectedCampaign = "";
  selectedMode = ReportMode.Sessions;
  isReportGenerating = true;
  isReportDownloading = false;
  isSummaryLoading = true;
  dropdownsLoading = true;
  enableSavesOnlyFilter: boolean = false;
  enableDetailedDownload: boolean = false;
  fieldLabels: { [key: string]: string } = {};
  showSummaryRow: boolean = false;
  ranges = {
    Today: [moment(), moment()],
    Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
    "Past 7 Days": [moment().subtract(7, "days"), moment()],
    "Month to Date": [moment().startOf("month"), moment()],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
    "Last 30 days": [moment().subtract(30, "days"), moment()],
    "Last 3 Months to Date": [
      moment().subtract(3, "months").startOf("month"),
      moment(),
    ],
    "Last 6 Months to Date": [
      moment().subtract(6, "months").startOf("month"),
      moment(),
    ],
    "Last 12 Months to Date": [
      moment().subtract(12, "months").startOf("month"),
      moment(),
    ],
    "Year to Date": [moment().startOf("year"), moment()],
    "Last Year": [
      moment().subtract(1, "year").startOf("year"),
      moment().subtract(1, "year").endOf("year"),
    ],
  };
  maxDate = moment();
  date: { startDate: Moment; endDate: Moment };
  timezone;
  dataFilterTypes = [
    { value: ReportMode.Sessions, text: "Sessions" },
    { value: ReportMode.Customer, text: "Customer" },
  ];

  summary: any = {};
  summaryFields = [];
  commonReportsFields = [];
  offerGroupFields: string[] = [];
  queryParams = { account_id: null, page: 1, page_size: config.maxPageSize };
  protected fieldData: ReportFieldData = reportsFieldDataV2;
  productsPage = 1;
  isConfigChanged = false;
  isSpChargebackReport = false;
  isChargebackReport = false;
  isChatbotReport = false;
  isGatewayTransactionReport = false;
  timeIntervals = Object.entries(this.ranges).map(([label, value]) => ({
    label,
    value,
  }));
  timezones: string[];
  saveParams = {
    reportName: "",
    selectedTimezone: "",
    selectedTimeInterval: [moment().subtract(7, "days"), moment()],
  };
  reportReq: any;
  reportType: number;
  isReportSaving: boolean = false;
  isReportDeleting: boolean = false;
  isCustomReport: boolean = false;
  customReportId = "";
  customReportName = "";
  isCustomReportLoading: boolean = false;
  protected _destroy$: Subject<boolean> = new Subject<boolean>();
  ordering: string[] = []
  public showSkewedNumbersWarning: boolean = false;
  fieldsToExcludeFromReport: string[] = [];
  fieldsNotHavingEmptyValue: ReportDimensions[] = [];
  switchFilterKeyMapping: {from: ReportDimensions, to: ReportDimensions}[] = [];
  excludeUpsells: boolean = false;
  showExcludeUpsellsFilter: boolean = false;
  excludeValidations: boolean = true;
  showExcludeValidationsFilter: boolean = false;
  retentionOnly: boolean = true;
  showRetentionOnlyFilter: boolean = false;
  excludePrefulfillmentCancels: boolean = false;
  showExcludePrefulfillmentCancelsFilter: boolean = false;
  excludeAbandons: boolean = false;
  showExcludeAbandonsFilter: boolean = false;
  excludeDuplicateViews: boolean = false;
  showExcludeDuplicateViewsFilter: boolean = false;
  retentionOnlyFlag: string = '';
  retentionOnlyLabel: string = '';
  customerStageOptions: string[] = [];
  isEmpty = (val) => isEmpty(val);

  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected alertService: AlertService,
    public reportsService: ReportsAbstractService,
    protected campaignService: CampaignService,
    protected reportsConfigService: ReportsConfigService,
    protected trackingSourceService: CampaignTrackingService,
    protected userService: UserService,
    protected accountService: AccountService,
    protected campaignProductService: CampaignProductService,
    protected crmCampaignService: CRMCampaignService,
    protected storageService: StorageService,
    protected stepService: FunnelStepService,
    protected merchantService: MerchantService,
    protected modalService: NgxSmartModalService,
    protected cancelReasonCategoryService: CancelReasonCategoryService
  ) {
    super(alertService, router, location);
  }

  ngOnInit() {
    this.timezones = momentTz.tz.names();
    this.currentUser = this.storageService.get("currentUser");
    this.queryParams.account_id = this.currentUser.account.id;
    this.initializeDate();

    // Initialize timezone before fetching filter data so date conversions work correctly
    this.timezone = this.storageService.get("timezone");
    if (!this.timezone) {
      this.timezone = momentTz.tz.guess();
    }
    this.saveParams.selectedTimezone = this.timezone;

    this.getFilterData();

    this.route.params.subscribe((params) => {
      if (params.id) {
        this.isCustomReport = true;
        this.customReportId = params.id;
        this.isCustomReportLoading = true;
        this.reportsConfigService
          .get(params.id)
          .pipe(takeUntil(this.destroy$))
          .subscribe(
            (config: ReportsUserConfiguration) => {
              this.isCustomReportLoading = false;
              this.customReportName = config.name;
              this.onCustomReportLoaded(config);
              this.selectedDimensions = config.configuration.dimensions;
              this.selectedFilters = config.configuration.filters;
              const [startDateString, endDateString] =
                config.time_interval.split(",");

              this.date = {
                startDate: moment(startDateString.trim()),
                endDate: moment(endDateString.trim()),
              };
              this.timezone = config.timezone;
              this.saveParams.selectedTimezone = this.timezone;

              this.filters.forEach((filter, index) => {
                const selectedFilter = this.selectedFilters.find(
                  (f) => f.model === filter.model
                );
                if (selectedFilter) {
                  this.filters[index].activeCount = selectedFilter.activeCount;
                  this.filters[index].options = selectedFilter.options;
                }
              });

              this.selectedDimensions.forEach((field) => {
                this.fields.forEach((x) => {
                  if (x.options && Array.isArray(x.options)) {
                    x.options = (x.options as MultiSubOption[]).map((option) =>
                      option.model === field.model ? field : option
                    );
                  }
                });
              });

              const fields = [];
              config.configuration.dimensions.forEach((dimension) => {
                fields.push(dimension.model);
              });
              this.updatePreSelectedDimensions(fields);
              this.reportReq = this.getQueryForReport();
              this.getSummary();
              // Refetch date-dependent filters with custom report's timezone
              this.getDateDependentFiltersData();
            },
            (error) => {
              this.alertService.error(error.message);
            }
          );
      } else {
        this.getSummary();
        this.reportReq = this.getQueryForReport();
      }
    });

    this.filterCommonDimensions(this.fieldsToExcludeFromReport)
    this.excludeFilters(this.fieldsToExcludeFromReport)
  }

  initializeDate() {
    this.date = {
      startDate: moment().subtract(7, "days").startOf("day"),
      endDate: moment().endOf("day"),
    };
    this.maxDate = this.date.endDate;
  }

  getDateDependentFiltersData() {
    this.getFilterItems().forEach((filter) => {
      switch (filter.model) {
        case "cancel_reason":
          this.getCancelReasons();
          break;
        case "product_path":
          this.getProductPaths();
          break;
        case "input_name":
          this.getNames();
          break;
      }
    });
  }

  getFilterData() {
    this.getFilterItems().forEach((filter) => {
      switch (filter.model) {
        case "product_id":
          this.getProducts({ searchTerm: "", nextPage: false });
          break;
        case "campaign_id":
          this.getCampaignsList();
          break;
        case "step_slug":
        case "last_hold_step":
        case "last_subscription_step":
        case "last_rma_step":
          this.getStepImpressions(filter.model);
          break;
        case "base_product_id":
          this.getBaseProducts();
          break;
        case "crm_campaign_id":
          this.getCRMCampaigns();
          break;
        case "merchant_id":
          this.getMerchants();
          break;
        case "tracking_source":
          this.getTrackingSources();
          break;
        case "cancel_reason_category":
          this.getCancelReasonCategories();
          break;
      }
    });
    this.getDateDependentFiltersData();
  }

  getCampaignsList() {
    if (this.currentUser.account.id) {
      this.campaignService
        .list({ is_hybrid: false, account_id: this.currentUser.account.id })
        .pipe(takeUntil(this._destroy$))
        .subscribe(
          (result: Pager) => {
            this.campaigns = result.results;
            this.dropdownsLoading = false;
            const campaignFilter = this.findFilter('campaign_id');
            if (campaignFilter) {
              campaignFilter.options = this.campaigns.map((d) => ({
                model: d.id.toString(),
                label: d.name,
                selected: false,
                disabled: false,
              }));
              campaignFilter.loading = false;
            }
          },
          (error) => {
            const campaignFilterErr = this.findFilter('campaign_id');
            if (campaignFilterErr) {
              campaignFilterErr.loading = false;
            }
            this.alertService.error(error.message);
          }
        );
    }
  }

  getCancelReasons() {
    const params = {
      ...this.queryParams,
      start_date: this.convertDateToUtc(this.date.startDate),
      end_date: this.convertDateToUtc(this.date.endDate),
    };

    // Capture previously selected values safely
    const selectedFilterOptions = this.getSelectedOptionsSet('cancel_reason');

    this.reportsService
      .getCancelReasons(params)
      .pipe(takeUntil(this._destroy$))
      .subscribe(
        (data) => {
          this.findFilter('cancel_reason').options = data.map((d) => ({
            model: d,
            label: d,
            selected: selectedFilterOptions.has(d),
            disabled: false,
          }));
          this.findFilter('cancel_reason').loading = false;
        },
        (error) => {
          this.findFilter('cancel_reason').loading = false;
          this.handleError(error);
        }
      );
  }

  getProductPaths() {
    const params = {
      ...this.queryParams,
      start_date: this.convertDateToUtc(this.date.startDate),
      end_date: this.convertDateToUtc(this.date.endDate),
    };

    // Capture previously selected values safely
    const selectedFilterOptions = this.getSelectedOptionsSet('product_path');

    this.reportsService
      .getProductPaths(params)
      .pipe(takeUntil(this._destroy$))
      .subscribe(
        (data) => {
          this.customerStageOptions = data;
          const productPathFilter = this.findFilter('product_path');
          if (productPathFilter) {
            productPathFilter.options = data.map((d: string) => ({
              model: d,
              label: d,
              selected: selectedFilterOptions.has(d),
              disabled: false,
            }));
            productPathFilter.loading = false;
          }
        },
        (error) => {
          const productPathFilterErr = this.findFilter('product_path');
          if (productPathFilterErr) {
            productPathFilterErr.loading = false;
          }
          this.handleError(error);
        }
      );
  }

  prependSelectedOptions(indexOrFilter: number | MultiOption, searchTerm?: string) {
    const filter = typeof indexOrFilter === 'number' ? this.filters[indexOrFilter] : indexOrFilter;
    const existingIds = new Set<number>();

    filter.options.forEach((opt: any) => {
      existingIds.add(opt.model);
    });

    const selectedOptions = Array.from(this.selectedProductMap.values());

    if (searchTerm) {
      // Search case → append selected AFTER searched options
      selectedOptions.forEach((opt) => {
        if (!existingIds.has(opt.model)) {
          filter.options.push(opt);
        }
      });
    } else {
      // Normal case → keep existing behavior (prepend)
      for (let i = selectedOptions.length - 1; i >= 0; i--) {
        if (!existingIds.has(selectedOptions[i].model)) {
          filter.options.unshift(selectedOptions[i]);
        }
      }
    }
  }


  getProducts({ searchTerm, nextPage }) {
    const index = this.filters.findIndex(
      (filter) => filter.model === ReportDimensions.ProductID
    );
    if (nextPage && this.filters[index].options.length >= 50) {
      this.productsPage++;
    } else this.productsPage = 1;

    const queryParams: CampaignProductsRequest = {
      accounts: this.queryParams.account_id,
      page: this.productsPage,
    };

    if (this.filters[index] && this.filters[index].options) {
      this.filters[index].options.forEach((opt: any) => {
        if (opt.selected) {
          this.selectedProductMap.set(opt.model, {
            model: opt.model,
            label: opt.label,
            selected: true,
            disabled: opt.disabled,
          });
        } else {
          this.selectedProductMap.delete(opt.model);
        }
      });
    }

    this.filters[index].paginationLoading = true;
    if (searchTerm) {
      if (this.productsPage === 1) this.filters[index].options = [];

      const productsApiCall = this.reportsService.getProducts({
        name__icontains: searchTerm,
        ...queryParams,
      });
      const campaignProductsApiCall = this.reportsService.getProducts({
        campaign_product_id: searchTerm,
        ...queryParams,
      });

      forkJoin([productsApiCall, campaignProductsApiCall])
        .pipe(
          takeUntil(this._destroy$),
          catchError((error) => {
            this.filters[index].loading = false;
            this.filters[index].paginationLoading = false;
            if (error.error.detail !== "Invalid page.") this.handleError(error);
            return of([]);
          })
        )
        .subscribe(([productsData, campaignProductsData]: any) => {
          const uniqueProductIds = new Set<number>();

          if (this.productsPage > 1 && productsData) {
            this.filters[index].options.push(
              ...productsData.results
                .filter((p) => !uniqueProductIds.has(p.id))
                .map((p) => {
                  uniqueProductIds.add(p.id);
                  return {
                    model: p.id,
                    label: `${p.name} (${p.campaign_product_id})`,
                    selected: this.selectedProductMap.has(p.id),
                    disabled: false,
                  };
                })
            );
          } else {
            if (productsData)
              this.filters[index].options = productsData.results.map((p) => ({
                model: p.id,
                label: `${p.name} (${p.campaign_product_id})`,
                selected: this.selectedProductMap.has(p.id),
                disabled: false,
              }));
          }

          if (campaignProductsData)
            this.filters[index].options.push(
              ...campaignProductsData.results
                .filter((p) => !uniqueProductIds.has(p.id))
                .map((p) => {
                  uniqueProductIds.add(p.id);
                  return {
                    model: p.id,
                    label: `${p.name} (${p.campaign_product_id})`,
                    selected: this.selectedProductMap.has(p.id),
                    disabled: false,
                  };
                })
            );

          this.filters[index].loading = false;
          this.filters[index].paginationLoading = false;
          this.prependSelectedOptions(index, searchTerm);
        });
    } else {
      this.reportsService
        .getProducts(queryParams)
        .pipe(takeUntil(this._destroy$))
        .subscribe(
          (data: any) => {
            if (this.productsPage > 1) {
              this.filters[index].options.push(
                ...data.results.map((p) => ({
                  model: p.id,
                  label: `${p.name} (${p.campaign_product_id})`,
                  selected: this.selectedProductMap.has(p.id),
                  disabled: false,
                }))
              );
            } else {
              this.filters[index].options = data.results.map((p) => ({
                model: p.id,
                label: `${p.name} (${p.campaign_product_id})`,
                selected: this.selectedProductMap.has(p.id),
                disabled: false,
              }));
            }

            this.filters[index].loading = false;
            this.filters[index].paginationLoading = false;
            this.prependSelectedOptions(index);
          },
          (error) => {
            this.filters[index].loading = false;
            this.filters[index].paginationLoading = false;
            if (error.error.detail !== "Invalid page.") this.handleError(error);
          }
        );
    }
  }

  getStepImpressions(fieldName: string) {
    if (!this.fieldsToExcludeFromReport.includes(fieldName)) {
      this.stepService
        .getGlobalJumpSteps(true, this.queryParams)
        .pipe(takeUntil(this._destroy$))
        .subscribe(
          (data: FunnelStep[]) => {
            if (this.findFilter(fieldName).options.length) {
              return;
            }

            this.findFilter(fieldName).options = data.map((d: FunnelStep) => ({
              model: fieldName.startsWith('last_') ? d.name : d.slug,
              label: `${d.name}`,
              selected: false,
              disabled: false,
            }));
            this.findFilter(fieldName).loading = false;
          },
          (error) => {
            this.findFilter(fieldName).loading = false;
            this.handleError(error);
          }
        );
    }
  }

  getCRMCampaigns() {
    this.crmCampaignService
      .listAll({ ...this.queryParams, "crm__type!": CRMTypeId.Test })
      .pipe(takeUntil(this._destroy$))
      .subscribe(
        (data: Pager) => {
          const crmFilter = this.findFilter('crm_campaign_id');
          if (crmFilter.options && crmFilter.options.length) {
            return;
          }

          crmFilter.options = data.results.map((d: CRMCampaign) => ({
            model: d.id,
            label: `${d.name} (${d.id})`,
            selected: false,
            disabled: false,
          }));
          crmFilter.loading = false;
        },
        (error) => {
          this.findFilter('crm_campaign_id').loading = false;
          this.handleError(error);
        }
      );
  }

  getBaseProducts() {
    // Overridden in ReportsAbstractV3Component
  }

  getNames() {
    const params = {
      ...this.queryParams,
      start_date: this.convertDateToUtc(this.date.startDate),
      end_date: this.convertDateToUtc(this.date.endDate),
    };

    // Capture previously selected values safely
    const selectedFilterOptions = this.getSelectedOptionsSet('input_name');

    this.reportsService
      .getInputNames(params)
      .pipe(takeUntil(this._destroy$))
      .subscribe(
        (data) => {
          const inputNameFilter = this.findFilter('input_name');
          if (inputNameFilter.options.length) {
            return;
          }

          inputNameFilter.options = data.map((d) => ({
            model: d.input_name,
            label: d.input_name,
            selected: selectedFilterOptions.has(d.input_name),
            disabled: false,
          }));
          inputNameFilter.loading = false;
        },
        (error) => {
          this.findFilter('input_name').loading = false;
          this.handleError(error);
        }
      );
  }

  getMerchants() {
    this.merchantService
      .list({ ...this.queryParams, "crm__type!": CRMTypeId.Test })
      .pipe(takeUntil(this._destroy$))
      .subscribe(
        (data: Pager) => {
          const merchantFilter = this.findFilter('merchant_id');
          if (merchantFilter.options.length) {
            return;
          }

          merchantFilter.options = data.results.map((d) => ({
            model: d.merchant_id,
            label: d.name,
            selected: false,
            disabled: false,
          }));
          merchantFilter.loading = false;
        },
        (error) => {
          this.findFilter('merchant_id').loading = false;
          this.handleError(error);
        }
      );
  }

  getCancelReasonCategories() {
    this.cancelReasonCategoryService
      .list({ ...this.queryParams })
      .pipe(takeUntil(this._destroy$))
      .subscribe(
        (data: Pager) => {
          const cancelCatFilter = this.findFilter('cancel_reason_category');
          cancelCatFilter.options = data.results.map((d: ReasonCategory) => ({
            model: d.name.toUpperCase(),
            label: d.name,
            selected: false,
            disabled: false,
          }));
          cancelCatFilter.loading = false;
        },
        (error) => {
          this.findFilter('cancel_reason_category').loading = false;
          this.handleError(error);
        }
      );
  }

  getTrackingSources() {
    this.trackingSourceService
      .list({ ...this.queryParams, "crm__type!": CRMTypeId.Test })
      .pipe(takeUntil(this._destroy$))
      .subscribe(
        (data) => {
          const trackingFilter = this.findFilter('tracking_source');
          if (trackingFilter.options.length) {
            return;
          }

          trackingFilter.options = data.map((d) => ({
            model: d.source,
            label: d.source,
            selected: false,
            disabled: false,
          }));
          trackingFilter.loading = false;
        },
        (error) => {
          this.findFilter('tracking_source').loading = false;
          this.handleError(error);
        }
      );
  }

  onCampaignChange(event) {
    this.isConfigChanged = true;
    this.selectedCampaign = event.target.value;
  }

  getSelectedOptionsSet(filterModel: string): Set<any> {
    const selectedSet = new Set<any>();

    const filter = this.findFilter(filterModel);

    if (filter && filter.options) {
      filter.options.forEach((option: any) => {
        if (option.selected) {
          selectedSet.add(option.model);
        }
      });
    }

    return selectedSet;
  }

  onCustomerModeChange(event) {
    this.isConfigChanged = true;
    this.selectedMode = event.target.value;
  }

  onTimezoneChange(event) {
    this.isConfigChanged = true;
    this.timezone = event.target.value;
    this.storageService.set('timezone', this.timezone);
    this.saveParams.selectedTimezone = this.timezone;
    // Refetch date-dependent filters with the new timezone's UTC conversion
    this.getDateDependentFiltersData();
  }

  /**
   * Converts a date to UTC based on the selected timezone.
   * Extracts the date/time components and interprets them as being in the selected timezone,
   * then converts to UTC.
   */
  convertDateToUtc(date: Moment): string {
    // Extract the date/time as a formatted string (without timezone info)
    let dateStr = date.format('YYYY-MM-DD HH:mm:ss');
    // Interpret the date string as being in the selected timezone, then convert to UTC
    return momentTz.tz(dateStr, 'YYYY-MM-DD HH:mm:ss', this.timezone).utc().format('YYYY-MM-DD HH:mm:ss');
  }

  openDatepicker() {
    this.pickerDirective.open();
  }

  onDateChange = (dateRange: { startDate: Moment; endDate: Moment }) => {
    if (!isEmpty(this.summary)) {
      this.isConfigChanged = true;
    }

    if (dateRange.startDate !== null && dateRange.endDate !== null) {
      this.date = {
        startDate: dateRange.startDate,
        endDate: dateRange.endDate,
      };
      this.getDateDependentFiltersData();
    }
  };

  onExcludeUpsellsChange() {
    if (!isEmpty(this.summary)) {
      this.isConfigChanged = true;
    }
  }

  onExcludeValidationsChange() {
    if (!isEmpty(this.summary)) {
      this.isConfigChanged = true;
    }
  }

  onRetentionOnlyChange() {
    if (!isEmpty(this.summary)) {
      this.isConfigChanged = true;
    }
  }

  onExcludePrefulfillmentCancelsChange() {
    if (!isEmpty(this.summary)) {
      this.isConfigChanged = true;
    }
  }

  onExcludeAbandonsChange() {
    if (!isEmpty(this.summary)) {
      this.isConfigChanged = true;
    }
  }

  onExcludeDuplicateViewsChange() {
    if (!isEmpty(this.summary)) {
      this.isConfigChanged = true;
    }
  }

  clearAllDimensions() {
    this.selectedDimensions = this.selectedDimensions.filter(
      (d) => d.selected === false
    );
    this.fields.forEach((option) => {
      option.options.forEach((sub) => {
        sub.selected = false;
        sub.disabled = false;
      });
    });
  }

  removeDimension(dimension: MultiSubOption) {
    this.selectedDimensions = this.selectedDimensions.filter(
      (d) => d.model !== dimension.model
    );
    const isRatioField =
      typeof dimension.model === "string" && dimension.model.includes("ratio");

    this.fields.forEach((option) => {
      option.options.forEach((sub) => {
        if (
          isRatioField &&
          (sub.model === ReportDimensions.TimePeriod || sub.model === ReportDimensions.MerchantID)
        ) {
          sub.selected = false;
          sub.disabled = false;
        }
        if (sub.model === dimension.model) {
          sub.selected = false;
        }
      });
    });
  }

  onDimensionsChange({ option, subOption }) {
    this.isConfigChanged = true;
    if (subOption.selected) this.selectedDimensions.push(subOption);
    else
      this.selectedDimensions = this.selectedDimensions.filter(
        (d) => d.model !== subOption.model
      );
  }

  onFiltersChange({ option, subOption }) {
    this.isConfigChanged = true;
    const isActive = this.selectedFilters.find(
      (filter) => filter.model === option.model
    );

    if (isActive) {
      if (option.activeCount === 0)
        this.selectedFilters = this.selectedFilters.filter(
          (filter) => filter.model !== option.model
        );
    } else {
      if (option.activeCount > 0) this.selectedFilters.push(option);
    }
  }

  onInputFiltersChange({ option, value }) {
    this.isConfigChanged = true;

    // Check if the option already exists in selectedFilters
    const existingFilter = this.selectedFilters.find(
      (filter) => filter.model === option.model
    );

    if (!existingFilter) this.selectedFilters.push({ ...option, value });
    else existingFilter.searchTerm = value;
  }

  onComparisonInputFiltersChange({ option, value, comparingOption }) {
    this.isConfigChanged = true;

    const existingFilter = this.selectedFilters.find(
      (filter) => filter.model === option.model
    );

    if (!existingFilter) {
      this.selectedFilters.push({ ...option, value, comparingOption });
    } else {
      existingFilter.searchTerm = value;
      existingFilter.selectedOption = option.selectedOption;
      existingFilter.comparingOption = comparingOption;
    }
  }

  removeFilter(filter: MultiOption) {
    this.selectedFilters = this.selectedFilters.filter(
      (d) => d.model !== filter.model
    );

    const activeFilters = this.filters.filter(
      (option) => option.activeCount > 0
    );

    this.filters.forEach((option) => {
      if (option.label === filter.label) {
        option.searchTerm = "";
        option.activeCount = 0;
        option.selectedOption = null;
        option.selected = false;

        option.options.forEach((sub) => {
          sub.selected = false;
        });
      }
    });

    if (activeFilters.length === 4) {
      this.filters.forEach((currentOption) => {
        currentOption.disabled = false;
        if (currentOption.options)
          currentOption.options.forEach((sub) => {
            sub.disabled = false;
          });
        else currentOption.disabled = false;
      });
    }
  }

  clearAllFilters() {
    this.selectedFilters = [];
    this.filters.forEach((option) => {
      option.disabled = false;
      option.searchTerm = "";
      option.selectedOption = null;
      option.activeCount = 0;
      option.selected = false;

      if (option.options)
        option.options.forEach((sub) => {
          sub.selected = false;
          sub.disabled = false;
        });
    });
  }

  clearSearchInputs() {
    this.filters.forEach((option) => {
      if (!(option.model === "billing_cycle" || option.model === "amount" || option.model === "message_count" || option.model === "chatbot_session_id")) {
        option.searchTerm = "";
      }
    });
    this.fields.forEach((option) => {
      option.searchTerm = "";
    });
  }

  protected findFilter(model: string): any {
    return this.filters.find(f => String(f.model) === model);
  }

  protected getFilterItems(): any[] {
    return this.filters;
  }

  protected buildSelectedFiltersMap(): { [key: string]: any } {
    return this.selectedFilters.reduce(
      (result, selectedFilter) => {
        const matchingFilter = this.findFilter(String(selectedFilter.model));

        if (matchingFilter) {
          if (matchingFilter.type === FilterType.Dropdown) {
            const selectedOptions = matchingFilter.options
              .filter((option) => option.selected)
              .map((option) => option.model);

            if (matchingFilter.singleValue) {
              if (selectedOptions.length > 0) {
                result[selectedFilter.model] = selectedOptions[0];
              }
            } else {
              result[selectedFilter.model] = selectedOptions;
            }
          } else if (matchingFilter.type === FilterType.Comparison) {
            if (
              "searchTerm" in selectedFilter &&
              "selectedOption" in selectedFilter &&
              selectedFilter.selectedOption !== "range" &&
              selectedFilter.selectedOption !== "e"
            ) {
              result[
                `${selectedFilter.model}__${selectedFilter.selectedOption}`
              ] = Number(selectedFilter.searchTerm);
            } else if (
              "searchTerm" in selectedFilter &&
              "selectedOption" in selectedFilter &&
              "comparingOption" in selectedFilter &&
              selectedFilter.selectedOption !== "e" // Here "e" represents the "equals to" model present in comparison options
            ) {
              result[
                `${selectedFilter.model}__${selectedFilter.selectedOption}`
              ] = [
                Number(selectedFilter.searchTerm),
                Number(selectedFilter.comparingOption),
              ];
            } else {
              result[selectedFilter.model] = Number(selectedFilter.searchTerm);
            }
          } else {
            result[selectedFilter.model] = this.getSearchTerm(selectedFilter.searchTerm);
          }
        }
        return result;
      },
      {}
    );
  }

  getQueryForSummary() {
    let filters = {};

    const selectedFilters = this.buildSelectedFiltersMap();

    if (this.predefinedFilters) {
      filters = { ...this.predefinedFilters, ...selectedFilters };
    } else {
      filters = { ...selectedFilters };
    }

    if (
      this.predefinedFields &&
      this.predefinedFields.length > 0 &&
      this.predefinedFields.every(
        (field) => !this.summaryFields.includes(field)
      )
    ) {
      this.summaryFields = this.summaryFields.concat(this.predefinedFields);
    }

    if (this.selectedCampaign) {
      filters['campaign_id'] = this.selectedCampaign;
    }


    if (this.showExcludeUpsellsFilter && this.excludeUpsells) {
      filters['product_type'] = ProductTypeEnum.Offer;
    }

    if (this.showExcludeValidationsFilter && this.excludeValidations) {
      filters['!cancel_reason'] = 'Validation';
    }

    let summaryFields = [...this.summaryFields];
    if (this.showRetentionOnlyFilter && this.retentionOnly && !summaryFields.includes(this.retentionOnlyFlag)) {
      summaryFields.push(this.retentionOnlyFlag);
    }

    if (this.showExcludePrefulfillmentCancelsFilter && this.excludePrefulfillmentCancels && !summaryFields.includes('exclude_prefulfillment_cancels')) {
      summaryFields.push('exclude_prefulfillment_cancels');
    }
    if (this.showExcludeAbandonsFilter && this.excludeAbandons && !summaryFields.includes('exclude_abandons')) {
      summaryFields.push('exclude_abandons');
    }

    return {
      accounts: [this.queryParams.account_id],
      customer_mode: this.selectedMode === ReportMode.Customer,
      date_filter_type: "sessions",
      date_range: {
        startDate: this.convertDateToUtc(this.date.startDate),
        endDate: this.convertDateToUtc(this.date.endDate),
      },
      fields: summaryFields,
      filters,
      timezone: this.timezone,
    };
  }

  getQueryForReport() {
    let filters = {};

    this.selectedDimensionsList = [].concat
      .apply(
        [],
        this.selectedDimensions.map((subItem) => subItem.model)
      )
      .concat(this.commonReportsFields);

    let selectedDimensions = this.selectedDimensionsList;

    const selectedFilters = this.buildSelectedFiltersMap();

    if (this.predefinedFilters) {
      filters = { ...this.predefinedFilters, ...selectedFilters };
    } else {
      filters = { ...selectedFilters };
    }

    if (this.selectedCampaign) {
      filters['campaign_id'] = this.selectedCampaign;
    }

    if (this.showExcludeUpsellsFilter && this.excludeUpsells) {
      filters['product_type'] = ProductTypeEnum.Offer;
    }

    if (this.showExcludeValidationsFilter && this.excludeValidations) {
      filters['!cancel_reason'] = 'Validation';
    }

    if (
      this.predefinedFields &&
      this.predefinedFields.length > 0 &&
      this.predefinedFields.every(
        (field) => !selectedDimensions.includes(field)
      )
    ) {
      selectedDimensions = selectedDimensions.concat(this.predefinedFields);
    }

    if (!this.date.startDate || !this.date.endDate) {
      this.initializeDate();
    }

    if (this.showRetentionOnlyFilter && this.retentionOnly && !selectedDimensions.includes(this.retentionOnlyFlag)) {
      selectedDimensions = selectedDimensions.concat(this.retentionOnlyFlag);
    }

    if (this.showExcludePrefulfillmentCancelsFilter && this.excludePrefulfillmentCancels && !selectedDimensions.includes('exclude_prefulfillment_cancels')) {
      selectedDimensions = selectedDimensions.concat('exclude_prefulfillment_cancels');
    }
    if (this.showExcludeAbandonsFilter && this.excludeAbandons && !selectedDimensions.includes('exclude_abandons')) {
      selectedDimensions = selectedDimensions.concat('exclude_abandons');
    }

    return {
      accounts: [this.queryParams.account_id],
      customer_mode: this.selectedMode === ReportMode.Customer,
      date_filter_type: "sessions",
      date_range: {
        startDate: this.convertDateToUtc(this.date.startDate),
        endDate: this.convertDateToUtc(this.date.endDate),
      },
      fields: selectedDimensions,
      filters,
      timezone: this.timezone,
      ordering: this.ordering
    };
  }

  getReport(fetchSummary: boolean = true) {
    this.isConfigChanged = false;
    this.isReportGenerating = true;
    if (this.reportsTable) {
      this.reportsTable.reportReq = this.getQueryForReport();
      this.reportsTable.resetPager();
      this.reportsTable.queryData(this.selectedDimensionsList);
      if (fetchSummary) {
        this.getSummary();
        this.clearSearchInputs();
      }
    }
  }

  getFieldValue(sessionInput: ReportSessionInput, field: string) {
    if (
      !this.fieldData[field] &&
      (field === "campaign" || field === "crm_campaign")
    ) {
      let data = chargebackFilters
        .find((data) => data.model === field)
        .options.find(
          (data) => String(data.model) === String(sessionInput[field])
        );
      return data ? data.label : "";
    }
    if (field.startsWith("exclude_")) {
      return "";
    }
    let value = get(sessionInput, field);
    let args = [sessionInput, value];
    if (
      ["date", "month", "year", "week", "hour", "order_date"].indexOf(field) >
      -1
    ) {
      args.push(this.storageService.get("timezone"));
    }
    if ("getter" in this.fieldData[field]) {
      value = this.fieldData[field].getter(...args);
      if (value !== 0 && !value) value = "";
    }

    return value;
  }

  getSummaryApiCalls() {
    return this.reportsService.getFilteredReport(this.getQueryForSummary(), "")
  }

  getSummary() {
    this.isSummaryLoading = true;
    this.getSummaryApiCalls()
      .pipe(takeUntil(this._destroy$))
      .subscribe(
        (result) => {
          const summaryData = {};
          const resp = result[0];

          this.summaryFields.forEach((key) => {
            if (ignoredSummaryFields.includes(key)) {
              return;
            }

            const formattedKey =
              this.fieldData[key].summary_label ||
              this.fieldData[key].custom_label ||
              this.fieldData[key].label;

            if (
              resp &&
              (resp[key] || resp[key] === null || resp[key] === 0) &&
              resp[key] !== undefined &&
              "getter" in this.fieldData[key]
            ) {
              summaryData[formattedKey] = this.fieldData[key].getter(
                {},
                resp[key]
              );
              if (!summaryData[formattedKey] && summaryData[formattedKey] !== 0)
                summaryData[formattedKey] = "--";
            } else {
              summaryData[formattedKey] = "--";
            }
          });

          this.summary = summaryData;
          this.isSummaryLoading = false;
        },
        (error) => {
          const summaryData = {};
          for (const key of this.summaryFields) {
            if (!ignoredSummaryFields.includes(key)) {
              const formattedKey =
                this.fieldData[key].summary_label ||
                this.fieldData[key].custom_label ||
                this.fieldData[key].label;
              summaryData[formattedKey] = "--";
            }
          }

          this.summary = summaryData;
          this.isSummaryLoading = false;
          this.handleError(error);
        }
      );
  }

  updateReportFlag() {
    this.isReportGenerating = false;
  }

  openSaveDialog() {
    this.modalService.open("saveReportModal");
    if (this.isCustomReport) this.saveParams.reportName = this.customReportName;
  }

  onSave(): void {
    const body = {
      name: this.saveParams.reportName,
      currency: "USD",
      time_interval: `${this.saveParams.selectedTimeInterval}`,
      timezone: this.saveParams.selectedTimezone,
      report_type: this.reportType,
      legacy: false,
      configuration: {
        dimensions: this.selectedDimensions,
        filters: this.selectedFilters,
      },
    };

    this.isReportSaving = true;
    if (!this.isCustomReport) {
      this.reportsService
        .saveReport(body)
        .pipe(takeUntil(this._destroy$))
        .subscribe(
          () => {
            this.isReportSaving = false;
            this.fetchReportConfing();
            this.onReportSaveSuccess();
            const [startDateString, endDateString] =
              body.time_interval.split(",");

            this.date = {
              startDate: moment(startDateString.trim()),
              endDate: moment(endDateString.trim()),
            };
            this.timezone = body.timezone;
            this.modalService.getModal("saveReportModal").close();
            this.alertService.success("Report Saved Successfully", true);
          },
          (error) => {
            this.isReportSaving = false;
            this.handleError(error);
          }
        );
    } else {
      this.reportsService
        .updateReport(this.customReportId, body)
        .pipe(takeUntil(this._destroy$))
        .subscribe(
          () => {
            this.isReportSaving = false;
            this.fetchReportConfing();
            this.onReportSaveSuccess();
            const [startDateString, endDateString] =
              body.time_interval.split(",");

            this.date = {
              startDate: moment(startDateString.trim()),
              endDate: moment(endDateString.trim()),
            };
            this.timezone = body.timezone;
            this.modalService.getModal("saveReportModal").close();
            this.customReportName = this.saveParams.reportName;
            this.alertService.success("Report Updated Successfully", true);
          },
          (error) => {
            this.isReportSaving = false;
            this.handleError(error);
          }
        );
    }
  }

  // Hook called after a report is successfully saved or updated. Override in subclasses to run post-save logic.
  protected onReportSaveSuccess(): void {}

  // Hook called after a custom report config is loaded by ID. Override in subclasses to react to the loaded config.
  protected onCustomReportLoaded(_config: ReportsUserConfiguration): void {}

  onCancel(): void {
    this.modalService.getModal("saveReportModal").close();
  }

  openDeleteDialog() {
    this.modalService.open("deleteReportModal");
  }

  onDelete() {
    this.isReportDeleting = true;
    this.reportsService
      .deleteReport(this.customReportId)
      .pipe(takeUntil(this._destroy$))
      .subscribe(
        () => {
          this.isReportDeleting = false;
          this.fetchReportConfing(true);
          this.alertService.success("Report Deleted Successfully");
          this.modalService.getModal("deleteReportModal").close();
        },
        (error) => {
          this.isReportDeleting = false;
          this.handleError(error);
        }
      );
  }

  onDeleteCancel(): void {
    this.modalService.getModal("deleteReportModal").close();
  }

  fetchReportConfing(routing = false) {
    this.reportsConfigService
      .list({})
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data: Pager) => {
          this.reportsConfigService._reportConfigSubject.next(data.results);
          if (routing) {
            const currentUrl = this.router.url;
            const baseUrl = currentUrl.split("/")[1];
            this.router.navigate(["/" + baseUrl]);
          }
        },
        (error) => {
          this.alertService.error(error.message);
        }
      );
  }

  downloadReport() {
    this.isReportDownloading = true;
    const req = {
      ...this.getQueryForReport(),
      start_date_formatted: this.date.startDate.format("MMM Do, YYYY"),
      end_date_formatted: this.date.endDate.format("MMM Do, YYYY"),
    };

    this.reportsService
      .getDownloadReportData(req)
      .pipe(tap(() => (this.isReportDownloading = false)))
      .subscribe(
        (data) => {
          downloadFromUrl(data.download_url);
        },
        (error) => {
          this.isReportDownloading = false;
          if (error.status === 404) {
            this.alertService.error("No reports to download");
            return;
          }
          this.alertService.error("An error occurred while downloading report");
        }
      );
  }

  getDimensionsLength() {
    let count = 0;
    this.selectedDimensions.forEach(() => {
      count++;
    });
    return count;
  }

  closeMenu() {
    this.isMenuVisible = false;
  }

  keepOrder = (a, b) => {
    return a;
  };

  updatePreSelectedDimensions(model: string | string[]) {
    if (Array.isArray(model)) {
      model.forEach((singleModel) => {
        const option = this.fields[
          ReportDimensionCategories.Dimensions
        ].options.find((opt) => opt.model === singleModel);
        if (option) {
          option.selected = true;
        }
      });
    } else {
      const option = this.fields[
        ReportDimensionCategories.Dimensions
      ].options.find((opt) => opt.model === model);
      if (option) {
        option.selected = true;
      }
    }
  }

  getSearchTerm(searchTerm: string): string | number {
    return this.isChatbotReport ? Number(searchTerm) : searchTerm;
}

  filterCommonDimensions(dimensions: string[]) {
    this.fields.forEach((field) => {
      for (let i = field.options.length - 1; i >= 0; i--) {
        if (dimensions.includes(field.options[i].model.toString())) {
          field.options.splice(i, 1);
        }
      }
    });
  }

  excludeFilters(dimensions: string[]) {
    this.filters = this.filters.filter((item) => !dimensions.includes(item.model as string));
  }

  onOrder(ordering: string[]) {
    this.ordering = ordering
    this.getReport(false)
  }

  switchFilterKeys(query) {
    this.switchFilterKeyMapping.forEach(mapping => {
      if (Object.keys(query.filters).includes(mapping.from)) {
        query.filters[mapping.to] = query.filters[mapping.from];
        delete query.filters[mapping.from];
      }
    })
  }

  applyExcludeEmptyValueFilter(query) {
    this.fieldsNotHavingEmptyValue.forEach(field => {
      if (query.fields.includes(field) && !Object.keys(query.filters).includes(field)) {
        query.filters[field] = 'not null';
      }
    })
  }
}
